import { useMemo } from "react"
import { Address } from "viem"
import { useAccount } from "wagmi"

import { MEZO_CHAIN, ONE_SECOND_IN_MILLISECONDS } from "#/shared/constants"
import { Router } from "#/shared/constants/artifacts"
import { SwapRoute } from "#/shared/types"
import { getSwapDeadline, getSwapMinAmountOut } from "#/shared/utils"

import { useEstimateTransactionGasWithApprove } from "../contract"

const refetchInterval = ONE_SECOND_IN_MILLISECONDS * 30 // 30 seconds

const useSwapGas = (
  amount: bigint,
  tokenInAddress: Address | undefined,
  routes: SwapRoute[],
  slippage: number,
) => {
  const { address } = useAccount()

  const queryEnabled = useMemo(
    () => !!address && !!routes.length && !!tokenInAddress && !!slippage,
    [address, routes.length, tokenInAddress, slippage],
  )

  return useEstimateTransactionGasWithApprove(
    {
      amountToSpent: amount,
      spender: Router.address,
      tokenContractAddress: tokenInAddress!,
    },
    {
      abi: Router.abi,
      address: Router.address,
      functionName: "swapExactTokensForTokens",
      args: [
        amount,
        getSwapMinAmountOut(amount, slippage),
        routes,
        address,
        getSwapDeadline(),
      ],
    },
    {
      chainId: MEZO_CHAIN.id,
      query: {
        enabled: queryEnabled,
        refetchInterval,
        staleTime: refetchInterval,
      },
    },
  )
}

export default useSwapGas
